export default {
  fulfilmentStatus: {
    'unfulfilled': 'Unfulfilled',
    'assigned': 'Assigned',
    'shipped': 'Shipped',
    'delivered': 'Delivered',
    'returninitiated': 'Return Initiated',
    'repairinitiated': 'Repair Initiated',
    'repairreceived': 'Repair Received',
    'returnreceived': 'Return Received',
    'returnrejected': 'Return Rejected',
    'noreturn': 'No Return',
    'refunded': 'Refunded',
    'cancelled': 'Cancelled',
    'returnnotreceived': 'Return Not Received',
    'replacementinitiated': 'Replacement Initiated',
    'partiallyrefunded': 'Partially Refunded',
    'confirmed': 'Confirmed',
    'inTransit': 'In Transit'
  },
  missingDiamondAndPaveId: [41698398634123, 41698398601355],
  earringBackReasonId:[7137553285259],
  hideReasonFromRcLoopId:[41698399027339, 41698398994571, 42545332060299, 42545333338251], // process.env.REACT_APP_NODE_ENV === 'production' Platting No charge, Polish No charge, Resizing no charge, Disc earring back no charge
  resizeProductId: [7178457776267, 7178457743499],
  earringBackProductsList: [7137553285259, 7475330711691, 7475330613387]
}